import type en from '../en/sites'
import type { Translation } from '../types'

/** Sites */
const sites: Translation<typeof en> = {
  "sites.deleted": "Sitio eliminado",
  "sites.deleteFailed": "No se pudo eliminar el sitio",
  "sites.syncTriggered": "Sincronización iniciada",
  "sites.syncFailed": "Error de sincronización",
  "sites.managed": { one: "{count} sitio gestionado", other: "{count} sitios gestionados" },
  "sites.addSite": "Añadir sitio",
  "sites.site": "Sitio",
  "sites.location": "Ubicación",
  "sites.lastSync": "Última sincronización",
  "sites.none": "Todavía no hay sitios — añada su primer sitio UniFi",
  "sites.notInLicence": "No incluido en su licencia",
  "sites.configureDevice": "Configurar dispositivo",
  "sites.syncNow": "Sincronizar ahora",
  "sites.confirmDelete": "¿Eliminar el sitio «{name}»?",
  "sites.add.title": "Añadir sitio UniFi",
  "sites.add.name": "Nombre del sitio *",
  "sites.add.namePlaceholder": "Sede central",
  "sites.add.locationPlaceholder": "Madrid, España",
  "sites.add.descriptionPlaceholder": "Descripción opcional",
  "sites.add.apiKey": "Clave de API de UniFi *",
  "sites.add.apiKeyPlaceholder": "Clave de API de UniFi Network Application",
  "sites.add.signInWith": "Iniciar sesión con",
  "sites.add.signInKey": "Clave de API (consola UniFi OS)",
  "sites.add.signInLogin": "Nombre de usuario y contraseña (Network Server autoalojado)",
  "sites.add.username": "Nombre de usuario *",
  "sites.add.password": "Contraseña *",
  "sites.add.loginHint": "Un Network Server autoalojado no tiene claves de API: utilice en él una cuenta local sin verificación en dos pasos. La contraseña se guarda cifrada y nunca se muestra.",
  "sites.add.controllerUrl": "URL del controlador",
  "sites.add.hintConsole": "Consola UniFi OS (Dream Machine, Cloud Gateway, Cloud Key):",
  "sites.add.hintSelfHosted": "Network Server autoalojado:",
  "sites.add.hintSiteManager": "Para consolas a las que accede mediante unifi.ui.com, use «+ Site Manager».",
  "sites.add.siteId": "ID del sitio",
  "sites.add.note": "Nota:",
  "sites.add.noteText": "Tras añadirlo, se crea automáticamente una cuenta VPN. El sitio se activará en cuanto se conecte por VPN.",
  "sites.synced": "Sincronizado",
  "sites.notFound": "Sitio no encontrado",
  "sites.back": "Volver a los sitios",
  "sites.firmwareAvailable": "⬆ Firmware disponible",
  "sites.lastSyncWhen": "Última sincronización {when}",
  "sites.never": "nunca",
  "sites.sync": "Sincronizar",
  "sites.tab.overview": "Resumen",
  "sites.tab.topology": "Topología",
  "sites.tab.devices": "Dispositivos ({count})",
  "sites.tab.vlans": "VLAN ({count})",
  "sites.tab.wifi": "Wi-Fi ({count})",
  "sites.tab.clients": "Clientes ({count})",
  "sites.tab.traffic": "Tráfico",
  "sites.tab.alerts": "Alertas",
  "sites.tab.alertsCount": "Alertas ({count})",
  "sites.connectedNow": "conectados ahora",
  "sites.connectionsUp": "conexiones activas",
  "sites.download": "Descarga",
  "sites.upload": "Subida",
  "sites.uploadRate": "{rate} de subida",
  "sites.experienceScore": "Puntuación de experiencia",
  "sites.wifiGood": "✓ Buena experiencia Wi-Fi",
  "sites.wifiFair": "⚠ Experiencia Wi-Fi aceptable",
  "sites.wifiPoor": "✕ Mala experiencia Wi-Fi",
  "sites.averageAcross": { one: "Media de {count} cliente inalámbrico", other: "Media de {count} clientes inalámbricos" },
  "sites.wanConnections": "Conexiones WAN",
  "sites.loadBalanced": "Balanceo de carga",
  "sites.noWan": "Todavía no hay datos WAN",
  "sites.throughput": "Rendimiento",
  "sites.noHistory": "Todavía no hay historial",
  "sites.noTopology": "No hay datos de topología — sincronice primero el sitio",
  "sites.networkTopology": "Topología de la red",
  "sites.connectionsCount": { one: "{count} conexión", other: "{count} conexiones" },
  "sites.legend.wired": "— Enlace por cable",
  "sites.legend.wireless": "– – Enlace inalámbrico (malla)",
  "sites.legend.ap": "📶 Punto de acceso",
  "sites.legend.switch": "🔀 Conmutador",
  "sites.legend.gateway": "🔒 Puerta de enlace",
  "sites.legend.clientCount": "🔵 = número de clientes",
  "sites.legend.update": "⬆ = actualización disponible",
  "sites.model": "Modelo",
  "sites.type": "Tipo",
  "sites.experience": "Experiencia",
  "sites.firmwareUpdate": "⬆ Actualización de firmware disponible",
  "sites.radios": "Radios",
  "sites.channel": "Canal {channel}",
  "sites.utilization": "Uso: {percent} %",
  "sites.noDevices": "No hay dispositivos",
  "sites.update": "⬆ Actualizar",
  "sites.uptime": "TIEMPO ACTIVO",
  "sites.clientsCaps": "CLIENTES",
  "sites.radioTable": "Tabla de radios",
  "sites.channelUtilization": "Uso del canal",
  "sites.portTable": "Tabla de puertos",
  "sites.port": "Puerto",
  "sites.portN": "Puerto {n}",
  "sites.speed": "Velocidad",
  "sites.down": "Inactivo",
  "sites.upBadge": "ACTIVO",
  "sites.downBadge": "INACTIVO",
  "sites.uptimeDays": "{d} d {h} h",
  "sites.uptimeHours": "{h} h {m} min",
  "sites.vlanId": "ID de VLAN",
  "sites.purpose": "Finalidad",
  "sites.subnet": "Subred",
  "sites.noVlans": "No hay VLAN",
  "sites.noWifi": "No hay redes Wi-Fi",
  "sites.guest": "INVITADOS",
  "sites.clientsLower": "clientes",
  "sites.busiest": "Más ocupado: {ap} ({count})",
  "sites.client": "Cliente",
  "sites.connection": "Conexión",
  "sites.noClients": "No hay clientes",
  "sites.conn.wired": "por cable",
  "sites.conn.wireless": "inalámbrico",
  "sites.dpi.0": "Otros",
  "sites.dpi.1": "Mensajería instantánea",
  "sites.dpi.2": "P2P",
  "sites.dpi.3": "Transferencia de archivos",
  "sites.dpi.4": "Streaming",
  "sites.dpi.5": "Correo",
  "sites.dpi.6": "VoIP",
  "sites.dpi.7": "Juegos",
  "sites.dpi.8": "Redes sociales",
  "sites.dpi.9": "Publicidad",
  "sites.dpi.10": "Web",
  "sites.dpi.11": "Seguridad",
  "sites.dpi.other": "Cat. {n}",
  "sites.noDpi": "No hay datos de DPI — requiere UniFi con DPI activada",
  "sites.trafficByCategory": "Tráfico por categoría",
  "sites.breakdown": "Desglose",
  "sites.noActiveAlerts": "No hay alertas activas",
  "sites.config.field.enableDisable": "Enlace activado",
  "sites.config.help.enableDisable": "Activar o desactivar el enlace ascendente",
  "sites.config.field.priority": "Prioridad",
  "sites.config.help.priority": "Gana el número más bajo cuando hay varios enlaces activos",
  "sites.config.field.failover": "Conmutación por error",
  "sites.config.help.failover": "Cambiar a un enlace de respaldo si este falla",
  "sites.config.field.loadBalance": "Balanceo de carga",
  "sites.config.help.loadBalance": "Repartir las sesiones entre los enlaces activos",
  "sites.config.field.weights": "Peso de balanceo",
  "sites.config.help.weights": "Parte del tráfico para este enlace",
  "sites.config.field.healthCheck": "Comprobación de estado",
  "sites.config.help.healthCheck": "Comprobar el enlace y marcarlo como caído si falla",
  "sites.config.field.smartQueue": "Smart Queue (QoS)",
  "sites.config.help.smartQueue": "Reducir el bufferbloat bajo carga",
  "sites.config.field.staticIp": "IP estática",
  "sites.config.help.staticIp": "Déjelo en blanco para DHCP",
  "sites.config.field.mtu": "MTU",
  "sites.config.help.mtu": "Normalmente 1500, o 1492 para PPPoE",
  "sites.config.field.simSwitch": "Ranura SIM activa",
  "sites.config.help.simSwitch": "El cambio corta brevemente la conexión",
  "sites.config.field.apn": "APN",
  "sites.config.help.apn": "Nombre del punto de acceso del operador",
  "sites.config.field.dataLimit": "Límite de datos mensual",
  "sites.config.help.dataLimit": "Las alertas saltan al 90 % de este valor",
  "sites.config.field.roaming": "Permitir itinerancia",
  "sites.config.help.roaming": "Costoso fuera de la red propia",
  "sites.config.field.bandLock": "Bloqueo de banda",
  "sites.config.help.bandLock": "Bandas separadas por comas, vacío = automático",
  "sites.config.field.pin": "PIN de la SIM",
  "sites.config.field.ssid": "SSID",
  "sites.config.field.security": "Seguridad",
  "sites.config.field.band": "Banda",
  "sites.config.field.guest": "Red de invitados",
  "sites.config.help.guest": "Aísla a los clientes de la LAN",
  "sites.config.field.vlanTag": "Etiqueta VLAN",
  "sites.config.field.schedule": "Programación activada",
  "sites.config.field.txPower": "Potencia de transmisión",
  "sites.config.field.fastRoaming": "Itinerancia rápida (802.11r)",
  "sites.config.field.mode": "Función",
  "sites.config.field.frequency": "Frecuencia",
  "sites.config.help.frequency": "Radios de 60 GHz: 58320, 60480, 62640, 64800 o 66000",
  "sites.config.field.channelWidth": "Ancho de canal",
  "sites.config.help.channelWidth": "No se usa en 60 GHz",
  "sites.config.field.protocol": "Protocolo",
  "sites.config.help.protocol": "Solo el controlador «wireless» de 2,4/5 GHz",
  "sites.config.field.linkKey": "Clave del enlace",
  "sites.config.help.linkKey": "Al menos 8 caracteres; debe coincidir en ambos extremos. No se vuelve a mostrar una vez guardada",
  "sites.config.field.linkTxPower": "Potencia de transmisión",
  "sites.config.help.linkTxPower": "Manténgase dentro del límite de su dominio normativo",
  "sites.config.field.linkSsid": "Nombre del enlace (SSID)",
  "sites.config.help.linkSsid": "Debe coincidir en ambos extremos",
  "sites.config.field.vlan": "VLAN",
  "sites.config.field.dhcp": "Servidor DHCP",
  "sites.config.field.firewall": "Cortafuegos",
  "sites.config.field.portForward": "Reenvío de puertos",
  "sites.config.field.staticRoutes": "Rutas estáticas",
  "sites.config.field.dns": "Servidores DNS",
  "sites.config.help.dns": "Separados por comas",
  "sites.config.field.speedfusion": "SpeedFusion",
  "sites.config.field.reconnect": "Reconectar túnel",
  "sites.config.help.reconnect": "Corta y restablece la agregación",
  "sites.config.field.createProfile": "Nuevo perfil",
  "sites.config.field.vpnClient": "Cliente VPN",
  "sites.config.field.reboot": "Reiniciar dispositivo",
  "sites.config.help.reboot": "El dispositivo queda sin conexión 1-2 minutos",
  "sites.config.field.firmwareCheck": "Buscar firmware",
  "sites.config.field.firmwareUpgrade": "Instalar firmware",
  "sites.config.help.firmwareUpgrade": "Aplica la última versión disponible",
  "sites.config.field.backup": "Copia de seguridad de la configuración",
  "sites.config.field.restore": "Restaurar configuración",
  "sites.config.field.ntp": "Servidor NTP",
  "sites.config.field.timezone": "Zona horaria",
  "sites.config.field.hostname": "Nombre de host",
  "sites.config.field.adminPassword": "Contraseña de administrador",
  "sites.config.section.wan": "WAN",
  "sites.config.blurb.wan": "Comportamiento del enlace ascendente, conmutación por error y balanceo de carga",
  "sites.config.section.cellular": "Móvil",
  "sites.config.blurb.cellular": "SIM, APN, límites de datos e itinerancia",
  "sites.config.section.wifi": "Wi-Fi",
  "sites.config.blurb.wifi": "SSID, seguridad y ajustes de radio",
  "sites.config.section.link": "Radioenlace",
  "sites.config.blurb.link": "Ajustes de enlaces punto a punto y punto a multipunto. Cambie primero cada estación y después el punto de acceso en un plazo de 10 minutos; la frecuencia solo se ajusta en el punto de acceso.",
  "sites.config.section.network": "Red",
  "sites.config.blurb.network": "VLAN, DHCP, cortafuegos y enrutamiento",
  "sites.config.section.tunnel": "Túneles",
  "sites.config.blurb.tunnel": "Perfiles de SpeedFusion y cliente VPN",
  "sites.config.section.system": "Sistema",
  "sites.config.blurb.system": "Reinicio, firmware, hora e identidad",
  "sites.config.option.ap-ptp": "Punto de acceso — punto a punto",
  "sites.config.option.ap-ptmp": "Punto de acceso — punto a multipunto",
  "sites.config.option.station": "Estación (extremo remoto / CPE)",
  "sites.config.option.open": "abierta",
  "sites.config.option.both": "ambas",
  "sites.config.option.auto": "automático",
  "sites.config.option.low": "baja",
  "sites.config.option.medium": "media",
  "sites.config.option.high": "alta",
  "sites.config.option.any": "cualquiera",
  "sites.config.applied": { one: "{count} cambio aplicado", other: "{count} cambios aplicados" },
  "sites.config.someFailed": "Algunos cambios han fallado",
  "sites.config.unsupportedHere": "No compatible con este dispositivo",
  "sites.config.title": "Configurar {name}",
  "sites.config.subtitle": "Solo se muestran las opciones compatibles con este dispositivo",
  "sites.config.hide": "Ocultar",
  "sites.config.history": "Historial",
  "sites.config.apply": "Aplicar {count}",
  "sites.config.missing": "Falta configuración: {items} — vuelva a conectar este sitio para habilitar la configuración.",
  "sites.config.readOnly": "{label} es de solo lectura en este panel. La monitorización sigue funcionando con normalidad.",
  "sites.config.readFailed": "No se pudieron leer los ajustes actuales del dispositivo",
  "sites.config.readFailedNote": "Los campos de abajo están vacíos porque se desconocen, no porque estén desactivados.",
  "sites.config.available": "Disponible en este dispositivo",
  "sites.config.appliesTo": "Se aplica a",
  "sites.config.notSupportedBy": "No compatible con {label}",
  "sites.config.raw": "Estado bruto del dispositivo",
  "sites.config.changed": "cambiado",
  "sites.config.notReported": "Estado actual no comunicado por el dispositivo",
  "sites.config.unknownState": "Estado actual desconocido",
  "sites.config.discard": "Descartar este cambio",
  "sites.config.historyTitle": "Historial de cambios de configuración",
  "sites.config.noChanges": "Todavía no se ha registrado ningún cambio",
  "sites.config.when": "Cuándo",
  "sites.config.section": "Sección",
  "sites.config.field": "Campo",
  "sites.config.value": "Valor",
  "sites.search": "Buscar sitios",
  "sites.searchPlaceholder": "Buscar por nombre…",
  "sites.brand": "Marca",
  "sites.allBrands": "Todas las marcas",
  "sites.noneMatch": "Ningún sitio coincide",
  "sites.matching": { one: "{count} sitio coincide", other: "{count} sitios coinciden" },
  "sites.config.offline.copy": "Esta unidad está desconectada — ajustes tal como se leyeron {when}. Los cambios se guardan y se envían cuando vuelva.",
  "sites.config.offline.none": "Esta unidad aún no se ha alcanzado — los cambios se guardan y se envían en el primer contacto.",
  "sites.config.offline.save": "Guardar para más tarde ({count})",
  "sites.config.offline.saved": { one: "{count} cambio guardado para cuando vuelva la unidad", other: "{count} cambios guardados para cuando vuelva la unidad" },
  "sites.config.offline.pendingValue": "pendiente: {value} · {by} · {when}",
  "sites.pending.title": "Cambios pendientes",
  "sites.pending.waitingUnit": "Se envía cuando vuelva la unidad",
  "sites.pending.conflict": "Cambiado en la unidad a {unit} — el tuyo: {mine}",
  "sites.pending.keepMine": "Mantener el mío",
  "sites.pending.keepUnit": "Mantener el de la unidad",
  "sites.pending.waitingFor": "Espera a que {names} reciba primero su propio cambio de enlace",
  "sites.pending.release": "Enviar de todos modos",
  "sites.pending.failed": "Error: {error}",
  "sites.pending.discard": "Descartar",
  "sites.pending.decision": "Decisión necesaria",
  "sites.pending.count": { one: "{count} pendiente", other: "{count} pendientes" },
  "sites.config.offline.noneSeen": "Esta unidad no responde ahora y sus ajustes aún no se han leído — los cambios se guardan y se envían en el próximo contacto.",
  "sites.cloud.status.OK": "Funciona",
  "sites.cloud.status.WAITING_VPN": "Esperando su VPN",
  "sites.cloud.status.FAILED": "Error",
  "sites.cloud.reach.PUBLIC": "En una dirección",
  "sites.cloud.reach.VIA_SITE_VPN": "A través de la VPN de un sitio",
  "sites.cloud.reach.OWN_VPN": "La propia conexión VPN del controlador",
  "sites.cloud.reachHint.PUBLIC": "El controlador responde en una dirección pública con un certificado válido.",
  "sites.cloud.reachHint.VIA_SITE_VPN": "Un dispositivo en uno de tus sitios con conexión VPN reenvía el puerto del controlador: sin suscripción en la nube ni puertos abiertos.",
  "sites.cloud.reachHint.OWN_VPN": "El equipo del controlador se conecta por sí mismo a la VPN de la plataforma (OpenVPN en Windows o Linux).",
  "sites.cloud.reachHint.needsVpn": "Requiere el permiso para gestionar conexiones VPN.",
  "sites.cloud.connectionName": "Nombre",
  "sites.cloud.connectionNamePlaceholder": "p. ej. Controlador de la sede",
  "sites.cloud.reachLabel": "Cómo llega el panel al controlador",
  "sites.cloud.address": "Dirección del controlador",
  "sites.cloud.addressHint": "Se necesita un certificado válido: en una dirección pública nada más demuestra quién responde.",
  "sites.cloud.noVpnSites": "Ninguno de tus sitios tiene aún conexión VPN. Añade uno primero (un MikroTik, una puerta de enlace UniFi o cualquier cliente VPN en ese lugar).",
  "sites.cloud.viaSite": "Sitio",
  "sites.cloud.chooseSite": "Elige un sitio",
  "sites.cloud.port": "Puerto del controlador",
  "sites.cloud.forwardIntro": "En el dispositivo de {site}, reenvía el puerto {port} de su dirección VPN {ip} a la dirección LAN del controlador.",
  "sites.cloud.lanAddress": "Dirección LAN del controlador",
  "sites.cloud.forwardMikrotik": "En un MikroTik, en su terminal:",
  "sites.cloud.lanPlaceholder": "<dirección LAN del controlador>",
  "sites.cloud.credentials": "Credenciales de Omada",
  "sites.cloud.credentialsWhere": "En el controlador Omada, abre {menu}, añade una aplicación en modo Client y copia su Client ID y su Client secret. El Omada ID aparece en la misma página.",
  "sites.cloud.omadacId": "Omada ID",
  "sites.cloud.clientId": "Client ID",
  "sites.cloud.clientSecret": "Client secret",
  "sites.cloud.keptPlaceholder": "Definido — déjalo vacío para conservarlo",
  "sites.cloud.registerTitle": "Añadir sitios Omada",
  "sites.cloud.registerSubtitle": "Los sitios de un controlador TP-Link Omada, alcanzado por tu VPN o en una dirección",
  "sites.cloud.savedWaiting": "Guardado — esperando la conexión VPN del controlador",
  "sites.cloud.connected": "Conectado al controlador",
  "sites.cloud.connectFailed": "No se pudo conectar",
  "sites.cloud.otherConnection": "Otra conexión",
  "sites.cloud.failed": "Último error: {reason}",
  "sites.cloud.editInSettings": "Editar la conexión",
  "sites.cloud.useConnection": "Usar una conexión",
  "sites.cloud.newConnection": "Una conexión nueva",
  "sites.cloud.connect": "Conectar",
  "sites.cloud.downloadFailed": "Error en la descarga",
  "sites.cloud.waitingTitle": "Esperando la conexión VPN del controlador",
  "sites.cloud.waitingText": "Descarga esta conexión VPN e iníciala en el equipo del controlador. Cuando el túnel esté activo se comprueban las credenciales y los sitios del controlador aparecen aquí; esta página vuelve a mirar cada 10 segundos.",
  "sites.cloud.downloadOvpn": "Descargar .ovpn",
  "sites.cloud.ovpnWindows": "Windows: instala OpenVPN, importa el archivo y conéctate; configura el servicio OpenVPN para que se inicie solo, así el túnel vuelve tras un reinicio.",
  "sites.cloud.ovpnLinux": "Linux: copia el archivo a /etc/openvpn/client/velanox.conf y ejecuta systemctl enable --now openvpn-client@velanox.",
  "sites.cloud.added": { one: "{count} sitio añadido", other: "{count} sitios añadidos" },
  "sites.cloud.addFailed": "No se pudieron añadir los sitios",
  "sites.cloud.sitesFailed": "No se pudieron leer los sitios del controlador: {reason}",
  "sites.cloud.controllerSites": "Sitios del controlador",
  "sites.cloud.noControllerSites": "El controlador no tiene sitios.",
  "sites.cloud.deviceCount": { one: "{count} dispositivo", other: "{count} dispositivos" },
  "sites.cloud.alreadyAdded": "Añadido",
  "sites.cloud.addSites": { one: "Añadir {count} sitio", other: "Añadir {count} sitios" },
  "sites.cloud.through": "A través de {name} · {reach}",
  "sites.cloud.synced": "sincronizado {when}",
  "sites.cloud.configure": "Configurar",
  "sites.cloud.devicesOnline": "Dispositivos en línea",
  "sites.cloud.clients": "Clientes",
  "sites.cloud.uplinksUp": "Enlaces activos",
  "sites.cloud.openAlerts": "Alertas abiertas",
  "sites.cloud.devices": "Dispositivos",
  "sites.cloud.noDevices": "Aún no hay dispositivos en este sitio.",
  "sites.cloud.type": "Tipo",
  "sites.cloud.uptime": "Tiempo activo",
  "sites.cloud.deviceType.ap": "Punto de acceso",
  "sites.cloud.deviceType.switch": "Switch",
  "sites.cloud.deviceType.gateway": "Puerta de enlace",
  "sites.cloud.deviceType.other": "Otro",
  "sites.cloud.updateAvailable": "Actualización disponible",
  "sites.cloud.restart": "Reiniciar",
  "sites.cloud.restartSent": "Reinicio enviado",
  "sites.cloud.restartConfirm": "¿Reiniciar {name}? Sus clientes pierden la conexión durante unos dos minutos.",
  "sites.cloud.upgrade": "Actualizar firmware",
  "sites.cloud.upgradeSent": "Actualización de firmware iniciada",
  "sites.cloud.upgradeConfirm": "¿Actualizar el firmware de {name}? Se reinicia y sus clientes pierden la conexión durante unos dos minutos.",
  "sites.cloud.noClients": "No hay clientes conectados.",
  "sites.cloud.connection": "Conexión",
  "sites.cloud.blocked": "Bloqueado",
  "sites.cloud.wireless": "Inalámbrico",
  "sites.cloud.wired": "Por cable",
  "sites.cloud.unblock": "Desbloquear",
  "sites.cloud.unblocked": "Desbloqueado",
  "sites.cloud.block": "Bloquear",
  "sites.cloud.blockedDone": "Bloqueado",
  "sites.cloud.blockConfirm": "¿Bloquear {name}? No podrá volver a conectarse hasta que se desbloquee.",
  "sites.cloud.reconnect": "Reconectar",
  "sites.cloud.reconnectSent": "Reconexión enviada",
  "sites.cloud.uplinks": "Enlaces",
  "sites.cloud.noUplinks": "No se informan enlaces.",
  "sites.cloud.up": "Activo",
  "sites.cloud.down": "Caído",
  "sites.cloud.alerts": "Alertas",
  "sites.cloud.events": "Eventos recientes de {vendor}",
  "sites.cloud.eventsFailed": "El controlador no respondió: {reason}",
  "sites.cloud.noEvents": "No hay eventos recientes.",
  "sites.config.field.ssidOn": "SSID activado",
  "sites.config.field.wifiKey": "Clave WiFi",
  "sites.config.help.wifiKey": "Solo escritura: la clave actual nunca se muestra",
  "sites.config.field.networkName": "Nombre de la red",
  "sites.config.field.siteName": "Nombre del sitio en el controlador",
  "sites.config.help.siteName": "El nombre propio del sitio en el panel se mantiene",
  "sites.config.secretSet": "Definida — escribe una nueva para cambiarla",
  "sites.cloud.lanAddressHint": "Su propia dirección en la red del sitio: el reenvío va hacia ella, y la red en la que está conserva su VLAN desde aquí.",
  "sites.cloud.controllerPort": "Puerto propio del controlador",
  "sites.cloud.controllerPortHint": "8043 en un controlador de software, 443 en un OC200 u OC300",
  "sites.cloud.secretAgain": "Vuelve a escribir el client secret si cambia la dirección, el sitio o el puerto: nunca se envía solo a una dirección nueva.",
  "sites.config.historySection.devices": "Dispositivos",
  "sites.config.historySection.clients": "Clientes",
  "sites.removeSite": "Eliminar el sitio",
  "sites.removeConfirm": "¿Eliminar el sitio «{name}»? Su historial, alertas, ajustes y conexión VPN se eliminan con él. No se puede deshacer.",
  "sites.config.help.radioOn": "Apagar una radio que lleva un enlace corta ese enlace",
  "sites.vpn.title": "Conexión VPN",
  "sites.vpn.connected": "Conectado",
  "sites.vpn.waiting": "Esperando su conexión VPN",
  "sites.vpn.notConnected": "No conectado",
  "sites.vpn.waitingPage": "Esperando su conexión VPN: los datos del dispositivo aparecen aquí en cuanto se conecte",
  "sites.vpn.tunnelAddress": "Dirección del túnel",
  "sites.vpn.lastSeen": "Última conexión",
  "sites.vpn.never": "Nunca",
  "sites.vpn.loadHint": "Cargue este archivo en el router como cliente OpenVPN y permita HTTPS (puerto 443) desde la VPN en el router (en un Teltonika: Red → Cortafuegos → Traffic rules, desde la zona openvpn hacia el dispositivo, TCP 443, aceptar); el sitio aparece en línea aquí en cuanto se conecte",
  "sites.vpn.download": "Descargar .ovpn",
  "sites.vpn.downloadFailed": "Error en la descarga",
  "sites.vpn.renew": "Renovar el certificado",
  "sites.vpn.renewed": "Nuevo archivo VPN creado para el sitio",
  "sites.vpn.renewFailed": "No se pudo crear un archivo VPN nuevo",
  "sites.signIn.change": "Cambiar el acceso",
  "sites.signIn.title": "Cambiar el acceso de {name}",
  "sites.signIn.hint": "Un campo vacío conserva lo guardado. Las contraseñas y tokens se guardan cifrados y nunca se muestran.",
  "sites.signIn.user": "Nombre de usuario",
  "sites.signIn.password": "Contraseña",
  "sites.signIn.token": "Token de API",
  "sites.signIn.apiKey": "Clave de API",
  "sites.signIn.save": "Guardar el acceso",
  "sites.signIn.saved": "Acceso guardado",
  "sites.signIn.savedText": "Se vuelve a consultar el dispositivo con él ahora",
  "sites.signIn.failed": "No se pudo guardar el acceso",
  "sites.direct.toggle": "Desactivar la conexión VPN y usar una dirección directa o IP",
  "sites.add.vpnLine": "Accesible por su conexión VPN, en la dirección del túnel de la puerta de enlace — se encuentra sola",
  "sites.event.brand": "Eventos",
  "sites.event.badge": "Evento",
  "sites.event.archived": "Archivado",
  "sites.archivedHint": "Sitios de eventos cerrados: se conservan aquí durante el plazo de archivo de los ajustes de alquiler y luego se eliminan.",
  "sites.event.rentalEvent": "Evento de alquiler",
  "sites.event.period": "Periodo de alquiler",
  "sites.event.material": "Material fuera y de vuelta",
  "sites.event.devices": "Dispositivos",
  "sites.event.device": "Dispositivo",
  "sites.event.cameIn": "Vino en",
  "sites.event.state": "Estado",
  "sites.event.uptime": "Tiempo activo",
  "sites.event.clients": "Clientes",
  "sites.event.traffic": "Tráfico",
  "sites.event.lastSeen": "Visto por última vez",
  "sites.event.noDevices": "Ningún dispositivo de lo cargado está fuera ahora",
  "sites.event.hidden": { one: "{count} dispositivo oculto: no puede ver su sitio", other: "{count} dispositivos ocultos: no puede ver sus sitios" },
  "sites.event.alerts": "Alertas",
  "sites.event.noAlerts": "Sin alertas",
  "sites.event.resolved": "resuelta",
  "sites.event.clientList": "Clientes de red",
  "sites.event.noClients": "Sin clientes",
  "sites.event.loads": "Lo que salió",
  "sites.event.noLoads": "Aún no ha salido nada",
  "sites.event.wentOut": "Fuera {when} · {who}",
  "sites.event.cameBack": "De vuelta {when} · {who}: {status}",
  "sites.event.stillOut": "aún fuera",
  "sites.event.cameBackOf": "{back} de {out} devueltos",
  "sites.event.graphs": "Gráficos",
  "sites.event.range": "Periodo",
  "sites.event.range24h": "24 h",
  "sites.event.range3d": "3 días",
  "sites.event.range1w": "1 semana",
  "sites.event.rangeThisMonth": "Este mes",
  "sites.event.rangeLastMonth": "El mes pasado",
  "sites.event.rangeCustom": "Personalizado",
  "sites.event.from": "Desde",
  "sites.event.to": "Hasta",
  "sites.event.rangeInvalid": "El final es anterior al inicio",
  "sites.event.totalInRange": "En este periodo: ↓ {rx} · ↑ {tx}",
  "sites.event.graphTraffic": "Tráfico total",
  "sites.event.graphDevices": "Dispositivos en línea y sin conexión",
  "sites.event.noSamples": "No hay nada registrado en este periodo: los gráficos se llenan mientras el material está fuera",
  "sites.event.asTable": "Mostrar como tabla",
  "sites.event.time": "Hora",
  "sites.cloud.username": "Nombre de usuario",
  "sites.cloud.password": "Contraseña",
  "sites.cloud.registerTitleSz": "Añadir sitios Ruckus",
  "sites.cloud.registerSubtitleSz": "Las zonas de un controlador Ruckus SmartZone, alcanzado a través de la VPN de un sitio o en una dirección",
  "sites.cloud.credentialsSz": "Credenciales de SmartZone",
  "sites.cloud.credentialsWhereSz": "Un administrador de SmartZone con un rol de lectura y escritura ({menu})",
  "sites.cloud.secretAgainSz": "Vuelva a escribir la contraseña cuando cambien la dirección, el sitio o el puerto: nunca se envía por sí sola a una dirección nueva.",
  "sites.cloud.controllerPortHintSz": "8443 en SmartZone",
  "sites.cloud.siteFirmware": "Actualizar el firmware de los AP",
  "sites.cloud.siteFirmwareCurrent": "Versión actual",
  "sites.cloud.siteFirmwareNew": "Versión nueva",
  "sites.cloud.siteFirmwareNone": "No hay ninguna versión más reciente en el controlador",
  "sites.cloud.siteFirmwareUpdate": "Actualizar",
  "sites.cloud.siteFirmwareConfirm": "Cada punto de acceso de este sitio se reinicia para pasar a {version}. ¿Continuar?",
  "sites.cloud.siteFirmwareSent": "Actualización de firmware iniciada",
  "sites.config.wifiOnly": "Los sitios de este controlador solo tienen ajustes WiFi: las VLAN se configuran por red WiFi.",
  "sites.event.comment": "Comentario",
  "sites.event.commentOf": "Comentario sobre {name}",
  "sites.event.commentPlaceholder": "Añadir un comentario",
  "sites.event.commentSaved": "Comentario guardado",
  "sites.event.commentFailed": "El comentario no se ha guardado",
  "sites.event.commentBy": "{name}, {when}",
  "sites.add.choose": "¿Qué desea añadir?",
  "sites.speedTest": "Prueba de velocidad ↓ {down} ↑ {up}",
  "sites.speedTestAt": "La última prueba de velocidad de la puerta de enlace, {when}: lo que admite la línea",
  "sites.dataUsed": "Datos usados ({period}): ↓ {rx} ↑ {tx}",
}

export default sites
